var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 16H16V496H496V16Z",
    fill: "#C0392B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M226.689 226.73H131.775L239.831 309.268L255.998 296.892L190.55 246.849L220.451 246.762L226.689 226.716",
    fill: "#27AE60"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.689 226.73V226.47H131L239.831 309.586L256.168 297.102L256.456 296.9L191.332 247.109L220.458 247.052H220.631L226.941 226.824L227.027 226.497H226.676V226.758L226.445 226.7L220.247 246.601L190.544 246.659H189.768L255.555 296.92L239.824 308.969L132.558 227.011H226.682V226.751L226.451 226.693L226.682 226.751",
    fill: "#27AE60"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M285.409 226.731L255.984 131.891L214.776 265.376L230.958 277.751L255.973 196.842L265.283 226.731H285.409",
    fill: "#27AE60"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M285.409 226.73L285.668 226.672L255.991 131L214.473 265.498L230.795 277.982L231.107 278.214L255.982 197.739L265.049 226.832L265.107 227.005H285.767L285.681 226.678L285.421 226.736V226.475H265.489L256.237 196.768L255.978 195.934L230.822 277.277L215.076 265.264L255.988 132.756L285.158 226.8L285.417 226.713V226.452V226.713",
    fill: "#27AE60"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M303.519 285.458L380.221 226.73L246.703 226.759L240.505 246.77H321.464L297.322 265.332L303.519 285.451",
    fill: "#27AE60"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M303.52 285.457L303.693 285.66L381 226.426L246.523 226.455L240.271 246.682L240.184 247.009H320.704L297.181 265.101L297.037 265.217L303.293 285.517L303.379 285.879L303.691 285.647L303.518 285.444L303.777 285.358L297.622 265.42L321.625 246.966L322.242 246.532H240.864L246.907 226.992L379.47 226.963L303.37 285.22L303.515 285.452L303.774 285.365L303.515 285.452",
    fill: "#27AE60"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M255.984 321.679L332.815 380.225L291.578 246.776H271.477L296.522 327.722L272.252 309.267L255.984 321.679",
    fill: "#27AE60"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M255.984 321.679L255.839 321.911L333.349 380.928L291.769 246.574H271.138L296.038 327.013L272.418 309.065L272.274 308.949L255.85 321.469L255.562 321.672L255.85 321.904L255.995 321.672L256.139 321.904L272.252 309.601L296.366 327.946L297.027 328.418L271.831 247.039H291.38L332.322 379.511L256.139 321.471L255.995 321.673L256.139 321.905L255.995 321.673",
    fill: "#27AE60"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M208.505 285.386L179.282 380.298L287.237 297.761L281.068 277.751L215.605 327.758L224.774 297.833L208.505 285.386",
    fill: "#27AE60"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M208.506 285.385L208.246 285.327L178.781 381L287.525 297.884L281.317 277.692L281.201 277.296L216.088 327.05L225.016 297.921L225.044 297.747L208.635 285.191L208.338 284.96L208.223 285.322L208.482 285.38L208.338 285.611L224.466 297.95L215.34 327.694L215.081 328.455L280.908 278.195L286.922 297.662L179.757 379.584L208.742 285.468L208.482 285.381L208.338 285.613L208.482 285.381",
    fill: "#27AE60"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMa);
export default __webpack_public_path__ + "static/media/MA.cb80fca163f17f1ce031064887a95fa9.svg";
export { ForwardRef as ReactComponent };